import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Auth from '@aws-amplify/auth';
import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(Auth.currentSession()).pipe(
      // tap(console.log),
      switchMap((session) => {
        const JWT = `Bearer ${session.getIdToken().getJwtToken()}`

        const modifiedReq = req.clone({
          setHeaders: {
            Authorization: JWT,
          },
        })
        if (req.url.includes('/push-admin-api/') || req.url.startsWith(environment.awsApiGateway) ) {
          return next.handle(modifiedReq)
        }
        return next.handle(req)
      }),
      catchError(e=>next.handle(req))
    )
  }
}
